import React, { useMemo } from "react";
import { Chip } from "@mui/material";
import GenericTable from "../GenericTable";

function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString("pt-BR");
}

const AgentLogsTable = ({
  logs = [],
  isLoading,
  page = 0,
  pageSize = 25,
  rowCount,
  onPageChange,
  onPageSizeChange,
}) => {
  const rows = useMemo(
    () =>
      (logs || []).map((log, index) => ({
        id: log.id ?? index,
        timestamp: log.timestamp || log.createdAt || log.created_at,
        skill: log.skill || log.skill_key || "—",
        input: log.input || log.userMessage || "",
        output: log.output || log.agentMessage || "",
        responseTimeMs:
          log.responseTimeMs ||
          log.latencyMs ||
          log.response_time_ms ||
          null,
        status: log.status || log.outcome || "ok",
      })),
    [logs]
  );

  const columns = [
    {
      field: "timestamp",
      headerName: "Data/Hora",
      width: 190,
      renderCell: (p) => <span>{formatDateTime(p.row.timestamp)}</span>,
    },
    {
      field: "skill",
      headerName: "Skill",
      width: 140,
    },
    {
      field: "input",
      headerName: "Entrada do usuário",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "output",
      headerName: "Resposta do agente",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "responseTimeMs",
      headerName: "Tempo de resposta (ms)",
      width: 170,
      renderCell: (p) =>
        p.row.responseTimeMs != null ? `${p.row.responseTimeMs}` : "—",
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (p) => {
        const v = (p.row.status || "").toLowerCase();
        const color =
          v === "ok" || v === "success" ? "success" : v === "error" || v === "fail" ? "error" : "default";
        return (
          <Chip
            size="small"
            label={p.row.status || "—"}
            color={color}
            variant="outlined"
          />
        );
      },
    },
  ];

  return (
    <GenericTable
      rows={rows}
      columns={columns}
      rowCount={rowCount ?? rows.length}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSearch={undefined}
      isLoading={isLoading}
      onExportPDFTitle="Logs do Agente Selecionados"
      exportFileName="agent-logs"
    />
  );
};

export default AgentLogsTable;

